<script setup lang="ts">
defineProps<{
  name: string
}>()

const payload = computed(() => {
  return {
    filters: [],
    sort: ""
  }
})
</script>

<template>
  <GAList id="plp" :name="name ?? ''" entity="pageList" :payload="payload">
    <slot />
  </GAList>
</template>
